import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useFilteredBranches } from '@/hooks/useFilteredBranches';
import { useBranch } from '@/contexts/BranchContext';

export const BranchSelector: React.FC = () => {
  const { branches, loading } = useFilteredBranches();
  const { selectedBranchId, setSelectedBranchId } = useBranch();

  if (loading) {
    return <div className="text-sm text-gray-500">Loading branches...</div>;
  }

  if (branches.length === 0) {
    return <div className="text-sm text-gray-500">No branches available</div>;
  }

  return (
    <Select value={selectedBranchId || ''} onValueChange={setSelectedBranchId}>
      <SelectTrigger className="w-[250px]">
        <SelectValue placeholder="Select a branch" />
      </SelectTrigger>
      <SelectContent>
        {branches.map((branch) => (
          <SelectItem key={branch.id} value={branch.id}>
            {branch.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
